import React from 'react'
import { Link } from 'gatsby'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import SEO from '../components/SEO'
import WelcomeBanners from '../components/welcome_banners'
import Welcome from '../components/welcome'
import ServiceFeatures from '../components/feature_list'

class IndexPage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {    
  
    var all_banners = this.props.data.allContentfulHeaderBanner.edges;
    var all_seo = this.props.data.allContentfulPageSeo.edges;
    var blogposts = this.props.data.allContentfulNewsArticle.edges;
    var posts = []    
    var pagename = 'index'
    var banners = []
    var classes = []
    var seo = []
    for (var i = 0; i < all_seo.length; i++) {
      var id_exists = false;
      for (var j =0; j < seo.length; j++) {
        if (all_seo[i].node.contentId == seo[j].node.contentId) { id_exists = true;}
      }      
      if (id_exists == false & all_seo[i].node.pageName == pagename) { seo.push(all_seo[i])}
    }    
    for (var i = 0; i < all_banners.length; i++) {      
      var id_exists = false;
      for (var j =0; j < banners.length; j++) {
        if (all_banners[i].node.contentId == banners[j].node.contentId) { id_exists = true;}
      }
      if (id_exists == false & banners.length < 6) { banners.push(all_banners[i])}
    }
    for (var i = 0; i < blogposts.length; i++) {      
      var slugexists = false;
      for (var j =0; j < posts.length; j++) {
        if (blogposts[i].node.slug == posts[j].node.slug) { slugexists = true;}
      }
      if (slugexists == false & posts.length < 8) { posts.push(blogposts[i])}
    }

    return(
      <Layout>
        <SEO pageSEOdata={seo}/>        
        <WelcomeBanners data={banners}/>
        <Welcome/>
        <ServiceFeatures posts={posts} />        
      </Layout>
    );
  }
}





export default IndexPage

export const query = graphql`
  query IndexQuery {
    allContentfulHeaderBanner(filter: {siteName: {eq: "aquaflow"}}) {
      edges {
        node {
          title
          subHeading
          image {
            fluid(maxWidth: 1800) {
              base64              
              srcWebp
              srcSetWebp
              aspectRatio
              sizes
              src
              srcSet
            }
          }
          buttonLink
          buttonText
          contentId
        }
      }
    }
    allContentfulNewsArticle(filter: {site: {eq: "aquaflow"}}) {
      edges {
        node {
          site
          slug
          heroImage {
            fluid(maxWidth: 600) {
              base64              
              srcWebp
              srcSetWebp
              aspectRatio
              sizes
              src
              srcSet
            }
          }
          title
          description {
            description
          }
        }     
      }
    }
    allContentfulPageSeo(filter: {siteName: {eq: "aquaflow"}}) {
      edges {
        node {
          contentId
          description
          googleSiteVerification
          keywords {
            keywords
          }
          ogdescription
          oglocale
          ogtitle
          ogtype
          ogurl
          pageName
          siteName
          title
          twittercard
          twittercreator
          twitterdescription
          twittertitle
        }
      }
    }
  }
`



